export default class AccountLogin {
  constructor(component) {
    this.dom = {
      $component: component,
      $formToggles: component.querySelectorAll('.js-toggleForm'),
    }
    this.state = {
      activeForm: 'login',
      activeFormClass: 'activeForm',
    }
    this.toggleFormHandler = this.toggleForm.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$formToggles.forEach($toggle => $toggle.addEventListener('click', this.toggleFormHandler))
  }

  toggleForm(event) {
    const { dom, state } = this
    const form = event.currentTarget.dataset.form
    const currentForm = dom.$component.querySelector(`.js-formWrap[data-form="${state.activeForm}"]`)
    const activeForm = dom.$component.querySelector(`.js-formWrap[data-form="${form}"]`)

    currentForm.setAttribute('aria-hidden', 'true')
    currentForm.setAttribute('aria-expanded', 'false')
    currentForm.classList.remove(state.activeFormClass)
    activeForm.setAttribute('aria-hidden', 'false')
    activeForm.setAttribute('aria-expanded', 'true')
    activeForm.classList.add(state.activeFormClass)
    state.activeForm = form
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.AccountLogin = this
  }
}
